module.exports = __webpack_public_path__ + "static/media/tempero-capa.1be4a76a.png";